import record from './modules/record'
import operation from './modules/operation'
import followup from './modules/followup'
import databank from './modules/databank'

export default {
  record,
  operation,
  followup,
  databank
}
